import { Button } from '@mui/material'
import { useCallback, useContext, useState } from 'react'
import { useWeb3Context, Web3ContextStatus } from 'src/contexts/web3Context'
import {
  CONNECT_YOUR_WALLET_MESSAGE,
  UNSUPORTED_NETWORK_MESSAGE,
  truncateStringInTheMiddle
} from 'src/utils/commons'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import { SnackbarContext } from 'src/contexts/SnackbarContext'
import ConfirmDialog from 'src/components/ConfirmDialog/ConfirmDialog'

export const ConnectButton = (): JSX.Element => {
  const { address, status, disconnect, connect } = useWeb3Context()
  const { setOpen, setColor, setMessage } = useContext(SnackbarContext)
  const [confirmOpen, setConfirmOpen] = useState(false)

  const handleDisconnect = useCallback(async () => {
    await disconnect()
  }, [])

  const handleConnect = useCallback(async () => {
    const status: Web3ContextStatus = await connect()
    if (status === Web3ContextStatus.WrongNetwork) {
      setMessage(UNSUPORTED_NETWORK_MESSAGE)
      setOpen(true)
      setColor('error')
      return
    }
    if (status === Web3ContextStatus.Error) {
      setMessage(CONNECT_YOUR_WALLET_MESSAGE)
      setOpen(true)
      setColor('error')
      return
    }
  }, [])

  if (status === Web3ContextStatus.WrongNetwork) {
    return (
      <Button
        startIcon={<AccountBalanceWalletIcon />}
        size={'medium'}
        color={'error'}
        variant={'outlined'}
        onClick={handleDisconnect}
      >
        Network!
      </Button>
    )
  }

  if (address) {
    return (
      <>
        <Button
          startIcon={<AccountBalanceWalletIcon />}
          size={'medium'}
          variant={'outlined'}
          onClick={() => setConfirmOpen(true)}
        >
          {truncateStringInTheMiddle(address, 6, 4)}
        </Button>
        <ConfirmDialog
          title="Disconnect your wallet?"
          open={confirmOpen}
          setOpen={setConfirmOpen}
          onConfirm={handleDisconnect}
        >
          Are you sure you want to disconnect from your wallet?
        </ConfirmDialog>
      </>
    )
  }

  return (
    <>
      <Button
        startIcon={<AccountBalanceWalletIcon />}
        size={'medium'}
        variant={'outlined'}
        onClick={handleConnect}
      >
        Connect
      </Button>
    </>
  )
}
